function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatPrompti = function SvgChatPrompti(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M20.086 6a2 2 0 0 0-2-2H6.194a2 2 0 0 0-2 2v14l4.725-3.062h9.167a2 2 0 0 0 2-2zM5.794 17.056l2.255-1.46a1.6 1.6 0 0 1 .87-.257h9.167a.4.4 0 0 0 .4-.4V6a.4.4 0 0 0-.4-.4H6.194a.4.4 0 0 0-.4.4zm6.195-4.02c-.443 0-.783.328-.783.755 0 .443.342.764.783.764s.783-.32.783-.764c0-.427-.34-.755-.783-.755m-1.665-5.608c.308-.368.872-.8 1.816-.8 1.588 0 2.403 1.124 2.403 2.23 0 1.362-.626 1.838-1.19 2.255-.1.08-.214.138-.31.19-.114.06-.22.1-.286.186-.073.103-.094.265-.094.553 0 .38-.315.674-.672.674a.664.664 0 0 1-.672-.674c0-.622.13-1.003.305-1.268.248-.372.6-.507.935-.752.358-.26.642-.46.642-1.163 0-.44-.347-.884-1.06-.884-.767 0-1.06.613-1.06 1.005a.68.68 0 0 1-.672.674.677.677 0 0 1-.672-.674 2.38 2.38 0 0 1 .587-1.551z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatPrompti);
export default ForwardRef;